import { Injectable } from '@angular/core';
import { PlantEndpoint } from '../../../../constants';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { Observable } from 'rxjs';
import { PlantModel, PlantRequestModel } from '../models';

@Injectable({
  providedIn: 'root',
})
export class PlantItemService {
  constructor(private http: WrapperHttpService) {}

  getPlantDetails(plantId: string): Observable<PlantModel> {
    return this.http.withLoading().get<PlantModel>(`${API_URL}${PlantEndpoint.Base}/${plantId}`);
  }

  createPlant(body: PlantRequestModel): Observable<PlantModel> {
    return this.http.withLoading().post<PlantModel>(`${API_URL}${PlantEndpoint.Base}`, body);
  }

  updatePlant(body: PlantRequestModel): Observable<PlantModel> {
    return this.http.withLoading().put<PlantModel>(`${API_URL}${PlantEndpoint.Base}`, body);
  }

  deletePlant(plantId: number): Observable<null> {
    return this.http.withLoading().delete<null>(`${API_URL}${PlantEndpoint.Base}/${plantId}`);
  }
}
